import { Action } from 'redux';
import { ServiceState, ServiceUnloadState } from '../../states/ServiceState';
import { Service } from '../../../models/Entities/Service';

export default function ServiceBaseReducer(
  state: ServiceState | undefined,
  action: Action
): ServiceState {
  const currentState = state ?? ServiceUnloadState;
  const a: any = action;

  switch (a.type) {
    // GET ALL
    case 'SERVICE_GET_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: false,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'SERVICE_GET_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        error: undefined,
        list: (currentState.list?.length ?? 0) > 0
          ? (a.Services || []).map((incomingService: Service) => {
              const existing = (currentState.list || []).find((s: Service) => s.id === incomingService.id);
              return existing ? { ...existing, ...incomingService } : incomingService;
            })
          : a.Services
      };
    case 'SERVICE_GET_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: a.error
      };

    // UPDATE ALL
    case 'SERVICE_UPDATE_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isUpdatingAll: true,
        isUpdatingAllSuccess: false,
        FailUpdatingAll: false,
        error: undefined
      };
    case 'SERVICE_UPDATE_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isUpdatingAll: false,
        isUpdatingAllSuccess: true,
        FailUpdatingAll: false,
        error: undefined,
        list: (currentState.list?.length ?? 0) > 0
          ? (a.Services || []).map((incomingService: Service) => {
              const existing = (currentState.list || []).find((s: Service) => s.id === incomingService.id);
              return existing ? { ...existing, ...incomingService } : incomingService;
            })
          : a.Services
      };
    case 'SERVICE_UPDATE_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isUpdatingAll: false,
        isUpdatingAllSuccess: false,
        FailUpdatingAll: true,
        error: a.error
      };

    // GET BY ID
    case 'SERVICE_GET_BY_ID_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingOne: true,
        successLoadingOne: false,
        failOnLoadingOne: false,
        error: undefined
      };
    case 'SERVICE_GET_BY_ID_RECEIVE_ACTION': {
      const CurrentService = (currentState.list || []).find((item: Service) => item.id === a.Service.id);
      const updatedService = CurrentService ? { ...CurrentService, ...a.Service } : a.Service;
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: true,
        failOnLoadingOne: false,
        error: undefined,
        list: CurrentService
          ? [...(currentState.list || []).filter((item: Service) => item.id !== a.Service.id), updatedService]
          : [...(currentState.list || []), a.Service]
      };
    }
    case 'SERVICE_GET_BY_ID_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: false,
        failOnLoadingOne: true,
        error: a.error
      };

    // GET BY CONSUMER ID
    case 'SERVICE_GET_BY_CONSUMER_ID_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingOne: true,
        successLoadingOne: false,
        failOnLoadingOne: false,
        error: undefined
      };
    case 'SERVICE_GET_BY_CONSUMER_ID_RECEIVE_ACTION': {
      // Merge incoming services with existing list
      const incomingServices = a.Services || [];
      const existingList = currentState.list || [];
      
      // Create a map of existing services by id
      const existingMap = new Map(existingList.map((s: Service) => [s.id, s]));
      
      // Update or add new services
      incomingServices.forEach((incoming: Service) => {
        const existing = existingMap.get(incoming.id);
        existingMap.set(incoming.id, existing ? { ...existing, ...incoming } : incoming);
      });
      
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: true,
        failOnLoadingOne: false,
        error: undefined,
        list: Array.from(existingMap.values())
      };
    }
    case 'SERVICE_GET_BY_CONSUMER_ID_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: false,
        failOnLoadingOne: true,
        error: a.error
      };

    // ADD
    case 'SERVICE_ADD_REQUEST_ACTION':
      return {
        ...currentState,
        isAdding: true,
        isAddingSuccess: undefined,
        failOnAdding: false,
        error: undefined
      };
    case 'SERVICE_ADD_RECEIVE_ACTION':
      return {
        ...currentState,
        isAdding: false,
        isAddingSuccess: true,
        failOnAdding: false,
        error: undefined,
        list: [...(currentState.list || []), a.Service]
      };
    case 'SERVICE_ADD_FAIL_ACTION':
      return {
        ...currentState,
        isAdding: false,
        isAddingSuccess: false,
        failOnAdding: true,
        error: a.error
      };

    // UPDATE
    case 'SERVICE_UPDATE_REQUEST_ACTION':
      return {
        ...currentState,
        isSaving: true,
        isSavingSuccess: undefined,
        failOnSaving: false,
        error: undefined
      };
    case 'SERVICE_UPDATE_RECEIVE_ACTION':
      return {
        ...currentState,
        isSaving: false,
        isSavingSuccess: true,
        failOnSaving: false,
        error: undefined,
        list: [...(currentState.list || []).filter((item: Service) => item.id !== a.Service.id), a.Service]
      };
    case 'SERVICE_UPDATE_FAIL_ACTION':
      return {
        ...currentState,
        isSaving: false,
        isSavingSuccess: false,
        failOnSaving: true,
        error: a.error
      };

    // DELETE
    case 'SERVICE_DELETE_REQUEST_ACTION':
      return {
        ...currentState,
        isDeleting: true,
        isDeletingSuccess: undefined,
        failOnDeleting: false,
        error: undefined
      };
    case 'SERVICE_DELETE_RECEIVE_ACTION':
      return {
        ...currentState,
        isDeleting: false,
        isDeletingSuccess: true,
        failOnDeleting: false,
        error: undefined,
        list: (currentState.list || []).filter((item: Service) => item.id !== a.ServiceId)
      };
    case 'SERVICE_DELETE_FAIL_ACTION':
      return {
        ...currentState,
        isDeleting: false,
        isDeletingSuccess: false,
        failOnDeleting: true,
        error: a.error
      };

    default:
      return currentState;
  }
}
